var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBottomRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 15,
    viewBox: "0 0 24 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1758 0.175781V14.1758",
    stroke: "#B3B3B3",
    strokeWidth: 0.35
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.175781 7.17578L23.1758 7.17578",
    stroke: "#B3B3B3",
    strokeWidth: 0.35
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1758 7.17578L11.1758 7.17578L11.1758 14.1758L22.1758 14.1758C22.7281 14.1758 23.1758 13.7281 23.1758 13.1758L23.1758 7.17578Z",
    fill: "#201CE0",
    stroke: "black",
    strokeWidth: 0.349105
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1.17553C0 0.526304 0.526304 0 1.17553 0H22.1755C22.8248 0 23.3511 0.526304 23.3511 1.17553V13.1755C23.3511 13.8248 22.8248 14.3511 22.1755 14.3511H1.17553C0.526303 14.3511 0 13.8248 0 13.1755V1.17553ZM1.17553 0.351064C0.720191 0.351064 0.351064 0.720191 0.351064 1.17553V13.1755C0.351064 13.6309 0.720191 14 1.17553 14H22.1755C22.6309 14 23 13.6309 23 13.1755V1.17553C23 0.720191 22.6309 0.351064 22.1755 0.351064H1.17553Z",
    fill: "black",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomRight);
export default __webpack_public_path__ + "static/media/bottom-right.7e31c2f16889b19d5e3235903aec0738.svg";
export { ForwardRef as ReactComponent };